import _Object$values from 'babel-runtime/core-js/object/values';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';

export default {
  name: 'industryCategoryCascader',

  componentName: 'industryCategoryCascader',

  props: {
    config: {
      type: Object,
      required: true
    },

    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      list: []
    };
  },


  computed: {
    innerConfig: function innerConfig() {
      var params = _extends({
        clearable: true,
        placeholder: '请选择行业类型',
        size: 'medium',
        valueKey: 'id',
        options: this.list
      }, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    }
  },

  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('config/getGmakerConfig');

            case 2:
              res = _context.sent;

              _this.list = _this.cookList(_.get(res, 'industry_categories'));

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    cookList: function cookList(list) {
      var map = {};
      list.forEach(function (item) {
        if (item.pid === 0) {
          map[item.id] = {
            value: item.id,
            pid: item.pid,
            label: item.name
          };
        }
      });
      list.forEach(function (item) {
        if (item.pid !== 0) {
          map[item.pid].children = map[item.pid].children || [];
          map[item.pid].children.push({
            value: item.id,
            label: item.name,
            pid: item.pid
          });
        }
      });
      return _Object$values(map);
    }
  }
};